import { shallowRef } from 'vue-demi';
import useRouter from './useRouter';

export default function useCurrentRoute() {
  const router = useRouter();
  const currentRoute = shallowRef(router.currentRoute);
  router.afterEach((newRoute) => {
    currentRoute.value = newRoute;
  });
  return currentRoute;
}
